module.exports = __webpack_public_path__ + "img/34.506e004d.jpg";